import { size } from "lodash";
import { ChevronsUpDown } from "lucide-react";
import { useMemo } from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useRefreshTokenMutation } from "@/data/mutations";
import { useGetOrganizationMembershipsQuery } from "@/data/queries";
import useStore from "@/state";

export const OrganizationSwitcher = () => {
  const { session } = useStore();
  const { data } = useGetOrganizationMembershipsQuery();
  const refreshTokenMutation = useRefreshTokenMutation();

  const activeOrganization = useMemo(() => {
    return data?.find(
      (membership) => membership.organization_id === session?.organization_id,
    );
  }, [data, session]);

  const handleOrganizationSelect = (organizationId: string) => {
    refreshTokenMutation.mutate(organizationId);
  };

  const hasMany = useMemo(() => size(data) > 1, [data]);

  if (!data) return null;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton size="lg">
              <Avatar className="h-8 w-8 rounded-lg">
                <AvatarImage alt="Legitimate" />
                <AvatarFallback className="rounded-lg">L</AvatarFallback>
              </Avatar>
              <span className="truncate font-medium">
                {activeOrganization?.organization_name ?? "Legitimate"}
              </span>
              {hasMany && <ChevronsUpDown className="ml-auto size-4" />}
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuLabel className="text-xs text-muted-foreground">
              Organizations
            </DropdownMenuLabel>
            {data.map((membership) => (
              <DropdownMenuItem
                key={membership.id}
                onClick={() =>
                  handleOrganizationSelect(membership.organization_id)
                }
              >
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage alt={membership.organization_name} />
                  <AvatarFallback className="rounded-lg">
                    {membership.organization_name?.[0]}
                  </AvatarFallback>
                </Avatar>
                {membership.organization_name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
